
//获取cookie
function getCookie(name){
    var strcookie = document.cookie;//获取cookie字符串
    var arrcookie = strcookie.split("; ");//分割
    //遍历匹配
    for ( var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name){
            return arr[1];
        }
    }
    return "";
}
//获取URL的值
function getParams() {
    let hrefStr = window.location.href;
    let paramObj = {};
    if (hrefStr.indexOf("?") > -1) {
        let paramArr = hrefStr.split("?")[1].split("&");
        for (let i = 0; i < paramArr.length; i++) {
            paramObj[paramArr[i].split("=")[0]] = paramArr[i].split("=")[1];
        }
    }
    return paramObj;
}
//获取查询框是否有值
function getQueryObj(obj){
    if (!obj)return false;
    for(let k in obj){
        if(k != "pageSize" && k != "pageNum" && k != "send" && k != "send1" && k != "send2" && k != "orderBy" && obj[k])return true;
    }
    return false;
}
function judge(arr,obj){
    let flag = 0;
    if(arr.length != 0){ //勾选
        return flag = 1;
    }else{
        if(getQueryObj(obj)){ //条件筛选
            return flag = 2;
        }
    }
    return flag;
}
//排序
function arrs(obj){
    obj.sort(function (m, n) {
        if (m < n) return -1
        else if (m > n) return 1
        else return 0
    });
}
function TimeChange(val){
    let params=[];
    if(val){
        params[0]= val[0];
        params[1]= val[1];
    }else{
        params[0]= '';
        params[1]= '';
    }
    return params;
}
function getCurrentDate(){
    // let date = new Date();
    let year = new Date().getFullYear()
    let month = new Date().getMonth() + 1; // 本月
    let days = new Date(year, month, 0).getDate(); // 本月总天数
    let M = month > 9 ? month : '0' + month;
    let D = days > 9 ? days : '0' + days;
    let times = year + '-' + M + '-' + D;

    let date = new Date();
    let aa = timestampToDate(date.setMonth((date.getMonth() - 11), 1))
    return [aa + ' 00:00:00', times + ' 23:59:59'];
}

function getCurDate3(Mon){
    let year = new Date().getFullYear()
    let month = new Date().getMonth() + 1; // 本月
    let days = new Date(year, month, 0).getDate(); // 本月总天数
    let M = month > 9 ? month : '0' + month;
    let D = days > 9 ? days : '0' + days;
    let times = year + '-' + M + '-' + D;

    let date = new Date();
    let aa = timestampToDate(date.setMonth((date.getMonth() - Mon), 1))
    return [aa + ' 00:00:00', times + ' 23:59:59'];
}

// 方法一：使用JavaScript内置的Date对象进行时间戳转日期的实现
function timestampToDate(timestamp) {
    let date = new Date(timestamp);
    let year = date.getFullYear();
    let month = date.getMonth() + 1; // 月份从0开始，需要加1
    let day = date.getDate();
    month = month > 9 ? month : '0' + month;
    day = day > 9 ? day : '0' + day;
    return `${year}-${month}-${day}`;
  }


//金额改为标准的保留两位小数
function HandleData(val){
    let a = val.toString().lastIndexOf('.');
    let b=  val.toString().length - 1
    if(a == -1){
        return (val=val+'.00');
    }else if((a != -1) && (b - a == 2)){
        return (val);
    }else if((a != -1) && (b - a == 1)){
        return (val = val+'0');
    }else{
        return (val); 
    }
}
//金额转大写
function convertCurrency(money) {
    //汉字的数字
    let cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
    //基本单位
    let cnIntRadice = new Array('', '拾', '佰', '仟');
    //对应整数部分扩展单位
    let cnIntUnits = new Array('', '万', '亿', '兆');
    //对应小数部分单位
    let cnDecUnits = new Array('角', '分', '毫', '厘');
    //整数金额时后面跟的字符
    let cnInteger = '';
    // let cnInteger = '整';
    //整型完以后的单位
    let cnIntLast = '元';
    //最大处理的数字
    let maxNum = 999999999999999.9999;
    //金额整数部分
    let integerNum;
    //金额小数部分
    let decimalNum;
    //输出的中文金额字符串
    let chineseStr = '';
    //分离金额后用的数组，预定义
    let parts;
    if (money == '') { return ''; }
    money = parseFloat(money);
    if (money >= maxNum) {
        //超出最大处理数字
        return '';
    }
    if (money == 0) {
        chineseStr = cnNums[0] + cnIntLast + cnInteger;
        return chineseStr;
    }
    //转换为字符串
    money = money.toString();
    if (money.indexOf('.') == -1) {
        integerNum = money;
        decimalNum = '';
    } else {
        parts = money.split('.');
        integerNum = parts[0];
        decimalNum = parts[1].substr(0, 4);
    }
    //获取整型部分转换
    if (parseInt(integerNum, 10) > 0) {
        let zeroCount = 0;
        let IntLen = integerNum.length;
        for (let i = 0; i < IntLen; i++) {
            let n = integerNum.substr(i, 1);
            let p = IntLen - i - 1;
            let q = p / 4;
            let m = p % 4;
        if (n == '0') {
            zeroCount++;
        } else {
            if (zeroCount > 0) {
            chineseStr += cnNums[0];
            }
            //归零
            zeroCount = 0;
            chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
        }
        if (m == 0 && zeroCount < 4) {
            chineseStr += cnIntUnits[q];
        }
        }
        chineseStr += cnIntLast;
    }
    //小数部分
    if (decimalNum != '') {
        let decLen = decimalNum.length;
        for (let i = 0; i < decLen; i++) {
            let n = decimalNum.substr(i, 1);
            if (n != '0') {
                chineseStr += cnNums[Number(n)] + cnDecUnits[i];
            }
        }
    }
    if (chineseStr == '') {
        chineseStr += cnNums[0] + cnIntLast + cnInteger;
    } else if (decimalNum == '') {
        chineseStr += cnInteger;
    }
    return chineseStr;
}
//处理排序的字段
function sortOpe(prop, order){
    let orderBy = '';
    if(order == 'descending'){
        orderBy = prop + ' desc';
    }else{
        orderBy = prop + ' asc';
    }
    return orderBy;
}
// js计算不精准的
// 加法：
function dcmAdd(arg1,arg2){
    var r1,r2,m; 
    try{r1=arg1.toString().split(".")[1].length;}catch(e){r1=0;}
    try{r2=arg2.toString().split(".")[1].length;}catch(e){r2=0;}
    m=Math.pow(10,Math.max(r1,r2));
    return (accMul(arg1,m)+accMul(arg2,m))/m;
}
// 减法：
function dcmsub(arg1,arg2){
    var r1,r2,m; 
    try{r1=arg1.toString().split(".")[1].length;}catch(e){r1=0;}
    try{r2=arg2.toString().split(".")[1].length;}catch(e){r2=0;}
    m=Math.pow(10,Math.max(r1,r2));
    return (accMul(arg1,m)-accMul(arg2,m))/m;
}
// 乘法：
function accMul(arg1,arg2){
    var m=0,s1=arg1.toString(),s2=arg2.toString();
    try{m+=s1.split(".")[1].length}catch(e){}
    try{m+=s2.split(".")[1].length}catch(e){}
    return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
}
function numberFormat(n, c, d, t){
    var c = isNaN(c = Math.abs(c)) ? 2 : c, 
        d = d == undefined ? "." : d, 
        t = t == undefined ? "," : t, 
        s = n < 0 ? "-" : "", 
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))), 
        j = (j = i.length) > 3 ? j % 3 : 0;
       return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};
//今日是否为当月的最后一天
function isLastDayOfMonth() {
    var flag = false;
    var date = new Date();

    var year = date.getFullYear();
    var month = date.getMonth()+1;
    var today = date.getDate();

    var new_year = year; //取当前的年份
    var new_month = month++;//取下一个月的第一天，方便计算（最后一天不固定）
    if(month>12){//如果当前大于12月，则年份转到下一年
        new_month -=12; //月份减
        new_year++; //年份增
    }
    var new_date = new Date(new_year,new_month,1); //取当年当月中的第一天

    var month_last_day = (new Date(new_date.getTime()-1000*60*60*24)).getDate();
    if(today == month_last_day){
        flag = true;
    }
    return flag;
}
//获取当前月份
function getNowMonth(){
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    month = month > 9 ? month :'0'+ month;
    var d = year+"-"+month;
    return d;
}
function getCurrentTime() {
    var date = new Date();//当前时间
    var year = date.getFullYear() //年
    var month = repair(date.getMonth() + 1);//月
    var day = repair(date.getDate());//日
    var hour = repair(date.getHours());//时
    var minute = repair(date.getMinutes());//分
    var second = repair(date.getSeconds());//秒
    
    //当前时间 
    var curTime = year + "-" + month + "-" + day
            + " " + hour + ":" + minute + ":" + second;
    return curTime;
}
 
//若是小于10就加个0
 
function repair(i){
    if (i >= 0 && i <= 9) {
        return "0" + i;
    } else {
        return i;
    }
}
// 获取本月第一天和最后一天的日期
function getMonthFirstAndLastDay() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    
    // 本月第一天
    const firstDay = new Date(year, month, 1);
    // 本月最后一天
    const lastDay = new Date(year, month + 1, 0);
    
    // 格式化为 YYYY-MM-DD
    const formatDate = (date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    };
    
    return [
        formatDate(firstDay),
        formatDate(lastDay)
    ];
}

/**
 * 判断操作系统
 */
function detectOS() {
    const isMac =
        navigator.platform === 'Mac68K' ||
        navigator.platform === 'MacPPC' ||
        navigator.platform === 'Macintosh' ||
        navigator.platform === 'MacIntel';

    if(navigator.platform === 'Win32' || navigator.platform === 'Windows'){
        return 'Windows'
    }else if(isMac){
        return 'Mac'
    }else if(String(navigator.platform).indexOf('Linux') > -1){
        return 'Linux'
    }else if(navigator.platform === 'X11' && !isWin && !isMac){
        return 'Unix'
    }else{
        return 'Unknown'
    }
}
//早于5点之前
function BeforeDefaultTime(paymentTime, H, HM){
    let year = new Date().getFullYear() //年
    let month = new Date().getMonth() + 1; // 月
    let days = new Date().getDate(); // 日
    month = month > 9 ? month : '0'+ month;
    days = days > 9 ? days : '0'+ days;
    let Rq = year + '-' + month +'-'+ days; //今天的日期
    //今天
    let flag = false;
    if(Rq == paymentTime){
        if(H < 16){
            flag = true
        }else{
            if(HM == '16:00:00'){
                flag = true;
            }
        }
    }else{
        flag = true;
    }
    return flag;
}
  
export default {
    getCookie:function(name){
        return getCookie(name)
    },
    getQueryObj:function(obj){
        return getQueryObj(obj)
    },
    judge:function(arr,obj){
        return judge(arr,obj)
    },
    arrs:function(obj){
        return arrs(obj)
    },
    getParams:function(){
        return getParams()
    },
    TimeChange:function(val,obj,obj1,obj2){
        return TimeChange(val,obj,obj1,obj2)
    },
    numberFormat:function(n,c,d,t){
        return numberFormat(n,c,d,t)
    },
    HandleData:function(val){
        return HandleData(val)
    },
    sortOpe:function( prop, order){
        return sortOpe(prop, order)
    },
    dcmAdd(arg1,arg2){
        return dcmAdd(arg1,arg2)
    },
    dcmsub(arg1,arg2){
        return dcmsub(arg1,arg2)
    },
    accMul(arg1,arg2){
        return accMul(arg1,arg2)
    },
    isLastDayOfMonth(){
        return isLastDayOfMonth()
    },
    getNowMonth(){
        return getNowMonth();
    },
    getCurrentTime(){
        return getCurrentTime();
    },
    convertCurrency(money){
        return convertCurrency(money);
    },
    detectOS(){
        return detectOS();
    },
    BeforeDefaultTime(paymentTime, H, HM){
        return BeforeDefaultTime(paymentTime, H, HM)
    },
    getCurrentDate(){
        return getCurrentDate()
    },
    getMonthFirstAndLastDay(){
        return getMonthFirstAndLastDay()
    },
    getCurDate3(Mon){
        return getCurDate3(Mon)
    }
}


// WEBPACK FOOTER //
// ./src/assets/script/common.js